'use client';

import { SwabKitProductDetailsBuyNow } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsBuyNow';
import { SwabKitProductDetailsDescription } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsDescription';
import { SwabKitProductDetailsIncluded } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsIncluded';
import { SwabKitProductDetailsLabCertified } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsLabCertified';
import { SwabKitProductDetailsNeedToKnow } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsNeedToKnow';
import { SwabKitProductDetailsPricing } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsPricing';
import { SwabKitProductDetailsTestingProcess } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsTestingProcess';
import { SwabKitProductDetailsTitle } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsTitle';
import { SwabKitProductDetailsTransformational } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsTransformational';
import { SwabKitProductDetailsYotpoShort } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetailsYotpoShort';
import { ShopSwabKitProductReview } from '@/components/alter25/shop/swab-kit/ShopSwabKitProductReview';

export const SwabKitProductDetails: React.FC = () => {
  return (
    <div className="">
      <SwabKitProductDetailsYotpoShort />
      <SwabKitProductDetailsTitle />
      <SwabKitProductDetailsPricing />
      <SwabKitProductDetailsBuyNow />
      {/* <SwabKitProductDetailsPromise /> */}

      <hr className="mb-8 mt-4 hidden lg:block bg-t-badge-gray " />

      <SwabKitProductDetailsTestingProcess />
      <SwabKitProductDetailsDescription />
      <SwabKitProductDetailsIncluded />
      <SwabKitProductDetailsLabCertified />
      {/* <SwabKitProductDetailsLabBatch /> */}
      <SwabKitProductDetailsNeedToKnow />
      <SwabKitProductDetailsTransformational />
      <ShopSwabKitProductReview className="block lg:hidden mt-12 lg:mt-0" />
      {/* <SwabKitProductDetailsChat /> */}
    </div>
  );
};
